import { render, staticRenderFns } from "./BatchCombine.template.vue?vue&type=template&id=24df5597&scoped=true&"
var script = {}
import style0 from "./BatchCombine.template.vue?vue&type=style&index=0&id=24df5597&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24df5597",
  null
  
)

export default component.exports